export default __webpack_public_path__ + "static/mkb-brandstof-8470a028b4c268e07b32e45926396ab7b315e4dee92a03784b8c2646ab61720b.svg";